/*

  From: https://www.npmjs.com/package/draft-js-import-element
  Version used: 1.2.1
  Last modified: 11.30.2017
  Things modified:
    - Removed "use strict" (only needed in npm package)
*/

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stateFromElement = require('./stateFromElement');

Object.keys(_stateFromElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _stateFromElement[key];
    }
  });
});